import { render, staticRenderFns } from "./AppMobile.vue?vue&type=template&id=71d26922&"
import script from "./AppMobile.vue?vue&type=script&lang=js&"
export * from "./AppMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports